/* ── styling ────────────────────────────────────────────────────── */
export const cardStyle = {
    background: '#fff', borderRadius: '14px', border: '1px solid #e2e8f0',
    padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
};
export const glassCard = {
    ...cardStyle,
    background: 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(248,250,252,0.9))',
    backdropFilter: 'blur(10px)',
};

export const tooltipStyle = {
    fontSize: '11px', borderRadius: '10px', border: '1px solid #e2e8f0',
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)', background: 'rgba(255,255,255,0.96)',
};